<template>
<div class="chapter">
<div class="inner_page">
<div class="titlepage">
<p class="center"><br/><br/></p>
<p class="center"><span class="big">Walking the<br/><br/> Appalachian Trail</span><br/><br/><br/></p>
<p class="center"><em>Larry Luxenberg<br/>Photographs by Mike Warren</em><br/><br/><br/><br/></p>
<p class="center"><span class="big2">STACKPOLE<br/> BOOKS</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780811744010_epub_tp_r1.vue?26412595